import { ListItem, Typography, Box } from '@material-ui/core'
import DragIndicatorIcon from '@material-ui/icons/DragIndicator'
import { PlaceholderImageWithIcon } from './placeholderImageWithIcon'
import { DraggableProvided } from '@hello-pangea/dnd'
import { FileInfo } from '../contextProvider'

interface FileItemProps {
  file: FileInfo
  index: number
  provided: DraggableProvided
}

const FileItem = ({ file, index, provided }: FileItemProps) => {
  return (
    <ListItem
      {...provided.draggableProps}
      {...provided.dragHandleProps}
      ref={provided.innerRef}
      disableGutters
    >
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'space-between',
          flexDirection: 'column',
          width: '100%',
          border: '1px solid #e0e0e0',
          borderRadius: '4px',
          padding: '8px',
        }}
      >
        <Box sx={{ display: 'flex', alignItems: 'center' }}>
          <Box style={{ cursor: 'grab', width: '24px' }}>
            <DragIndicatorIcon />
          </Box>
          <PlaceholderImageWithIcon imageSizeInPixels={44} />
          <Typography style={{ fontWeight: 'bold' }}>
            {index + 1}. {file.name}
          </Typography>
        </Box>
      </Box>
    </ListItem>
  )
}

export default FileItem
